import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

/**
 * PremiumModal — thin themed wrapper around reactstrap Modal.
 * Behaviour preserved (open/close, isOpen, toggle, size); only visual treatment changes via .modal-pm class.
 */
const PremiumModal = ({
  isOpen,
  toggle,
  title,
  size = "md",
  footer,
  bodyClassName = "",
  className = "",
  scrollable = false,
  children,
  ...rest
}) => (
  <Modal
    isOpen={isOpen}
    toggle={toggle}
    size={size}
    centered
    scrollable={scrollable}
    modalClassName={`modal-pm ${className}`}
    {...rest}
  >
    {title && <ModalHeader toggle={toggle}>{title}</ModalHeader>}
    <ModalBody className={bodyClassName}>{children}</ModalBody>
    {footer && <ModalFooter>{footer}</ModalFooter>}
  </Modal>
);

export default PremiumModal;
